import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, className = "", y = 40 }) => (
  <motion.div
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.8, delay, ease: [0.22, 1, 0.36, 1] }}
    className={className}
  >
    {children}
  </motion.div>
);

export const Overline = ({ children, className = "" }) => (
  <span
    className={`text-xs font-bold tracking-[0.25em] uppercase text-volt ${className}`}
  >
    {children}
  </span>
);

export const VoltButton = ({ children, className = "", as = "a", ...props }) => {
  const Comp = as;
  return (
    <Comp
      className={`group relative inline-flex items-center justify-center gap-2 bg-volt px-7 py-4 text-sm font-bold uppercase tracking-wider text-ink transition-colors duration-300 hover:bg-volt-hover ${className}`}
      {...props}
    >
      {children}
    </Comp>
  );
};

export const OutlineButton = ({ children, className = "", as = "a", ...props }) => {
  const Comp = as;
  return (
    <Comp
      className={`inline-flex items-center justify-center gap-2 border border-white/25 px-7 py-4 text-sm font-bold uppercase tracking-wider text-white transition-colors duration-300 hover:border-volt hover:text-volt ${className}`}
      {...props}
    >
      {children}
    </Comp>
  );
};
